export const textVariants = {
    displayLarge: {
        fontSize: 92,
        lineHeight: 104,
        fontWeight: '600',
    },
    displayMedium: {
        fontSize: 38,
        lineHeight: 44,
        fontWeight: '800',
    },
    displaySmall: {
        fontSize: 34,
        lineHeight: 44,
        fontWeight: '600',
    },
    headlineLarge: {
        fontSize: 28,
        lineHeight: 36,
        fontWeight: '600',
    },
    headlineMedium: {
        fontSize: 22,
        lineHeight: 32,
        fontWeight: '700',
        letterSpacing: -0.26,
    },
    headlineSmall: {
        fontSize: 20,
        lineHeight: 28,
        fontWeight: '600',
    },
    titleXLarge: {
        fontSize: 20,
        lineHeight: 24,
        fontWeight: '800',
        letterSpacing: -0.8,
    },
    titleLarge: {
        fontSize: 17,
        lineHeight: 24,
        fontWeight: '600',
    },
    titleMedium: {
        fontSize: 15,
        lineHeight: 24,
        fontWeight: '600',
        letterSpacing: -0.23,
    },
    titleSmall: {
        fontSize: 13,
        lineHeight: 20,
        fontWeight: '600',
    },
    bodyLarge: {
        fontSize: 17,
        lineHeight: 25,
        fontWeight: '400',
    },
    bodyMedium: {
        fontSize: 15,
        lineHeight: 24,
        fontWeight: '400',
        letterSpacing: -0.23,
    },
    bodySmall: {
        fontSize: 13,
        lineHeight: 20,
        fontWeight: '400',
    },
    bodySmaller: {
        fontSize: 12,
        lineHeight: 20,
        fontWeight: '400',
    },
    bodyXSmall: {
        fontSize: 12,
        lineHeight: 16,
        fontWeight: '400',
    },
    labelLarge: {
        fontSize: 13,
        lineHeight: 20,
        fontWeight: '500',
    },
    labelMedium: {
        fontSize: 12,
        lineHeight: 16,
        fontWeight: '500',
    },
    labelSmall: {
        fontSize: 11,
        lineHeight: 16,
        fontWeight: '500',
    },
    buttonLabel: {
        fontSize: 15,
        lineHeight: 24,
        fontWeight: '600',
    },
    iconFallback: {
        fontSize: 17,
        lineHeight: 17,
    },
    teamLogoFallback: {
        fontSize: 24,
        lineHeight: 40,
    },
    // Currently using Arcade product to test new variatns. We will potentially update all variants to use these if design is happy with them.
    bodySmall2: {
        fontWeight: '400',
        fontSize: 14,
        lineHeight: 20,
        letterSpacing: -0.15,
    },
    bodyMedium2: {
        fontSize: 16,
        lineHeight: 24,
        fontWeight: '400',
        letterSpacing: -0.31,
    },
    labelLarge2: {
        fontWeight: '500',
        fontSize: 14,
        lineHeight: 20,
        letterSpacing: -0.15,
    },
    titleMedium2: {
        fontWeight: '600',
        fontSize: 16,
        lineHeight: 24,
        letterSpacing: -0.31,
    },
    titleLarge2: {
        fontWeight: '600',
        fontSize: 18,
        lineHeight: 24,
        letterSpacing: -0.31,
    },
    headlineSmall2: {
        fontWeight: '600',
        fontSize: 24,
        lineHeight: 32,
        letterSpacing: 0.07,
    },
} as const;
